import React, { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BotCandlestickChart from './BotCandlestickChart';



// ... [Other components like Modal, Spinner, etc. remain unchanged] ...
const Spinner = () => (
  <div style={styles.spinnerContainer}>
    <div style={styles.spinner}></div>
    <p>Loading your dashboard...</p>
  </div>
);



const ErrorMessage = ({ message }) => (
  <div style={styles.errorBox}>
    <p>{message}</p>
  </div>
);

const ReferralInfo = () => (
  <div>
    <p>
      Additionally, you can increase your earnings by referring others to our platform.
      For each person you refer, you both will earn $1 and 💰 100,000 SVP token reward each. Our referral program is designed
      to benefit both you and the person you refer, Your earnings will be reflected instantly in your coin box
    </p>
  </div>
);

// Spinner small for button
const ButtonSpinner = () => (
  <div style={{
    border: '2px solid #f3f3f3',
    borderTop: '2px solid white',
    borderRadius: '50%',
    width: 16,
    height: 16,
    animation: 'spin 1s linear infinite',
    marginLeft: 8,
  }} />
);


const API_CLAIMCOIN_URL = 'https://www.sharedvision-partners.online/v1/API/claimCoin.php';
const API_ACTIVATEBOT_URL = 'https://www.sharedvision-partners.online/v1/API/toggleBot.php';
const API_REWARDBOT_URL = 'https://www.sharedvision-partners.online/v1/API/check_reward_status.php';

const HelpBox = () => (
  <div style={styles.helpBox}>
    <p>If you require assistance with our services, our bot is available to help you.</p>
    <div style={styles.linkContainer}>
      <a href="https://t.me/+0WQkWfyFmGczMjdh" target="_blank" rel="noopener noreferrer" style={styles.link}>
        <img src="/tg.png" alt="Telegram Support" style={styles.icon} />
      </a>
      <a href="https://whatsapp.com/channel/0029Vb4PrsFGehEO5SQZSb0E" target="_blank" rel="noopener noreferrer" style={styles.link}>
        <img src="/whatApp.png" alt="WhatsApp Support" style={styles.icon} />
      </a>
    </div>
  </div>
);

const CustomConfirmModal = ({ onSelect, onClose }) => (
  <div role="dialog" aria-modal="true" style={styles.modalOverlay}>
    <div style={styles.modalContent}>
      <p>Activate Bot using:</p>
      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
        <button onClick={() => onSelect('coins')} style={styles.modalButton}>500,000 Coins</button>
        <button onClick={() => onSelect('balance')} style={{ ...styles.modalButton, backgroundColor: '#28a745' }}>$5</button>
      </div>
      <button onClick={onClose} style={{ ...styles.modalButton, marginTop: '10px' }}>Cancel</button>
    </div>
  </div>
);


const Home = ({ userDetails: initialUserDetails, loading = false, error = null, activationEndTime: serverActivationEnd }) => {
  const [userDetails, setUserDetails] = useState(initialUserDetails); // 🆕 Local mirror

  const [botActive, setBotActive] = useState(false);
  const [coins, setCoins] = useState(0);
  const [dailyCoins, setDailyCoins] = useState(0);
  const [balance, setBalance] = useState(0);
  const [botEarn, setBotEarn] = useState(0);
  const [showConfirm, setShowConfirm] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [botLoading, setBotLoading] = useState(false);
  const [claimLoading, setClaimLoading] = useState(false);

  const [rewardClaimed, setRewardClaimed] = useState(null);
const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  // Sync local userDetails with props
  useEffect(() => {
    setUserDetails(initialUserDetails);
  }, [initialUserDetails]);

  useEffect(() => {
    if (userDetails) {
    setCoins(Number.parseInt(userDetails?.coins ?? 0));
      setDailyCoins(parseInt(userDetails.dailyCoins) || 0);
      setBalance(parseFloat(userDetails.balance) || 0);
      setBotEarn(parseFloat(userDetails.botEarn) || 0);
    
         // ✅ Check botStatus and set botActive
    const isBotActive = userDetails.botStatus === "1" || userDetails.botStatus === 1;
    setBotActive(isBotActive);
  }
    
  }, [userDetails]);

  const fetchRewardStatus = useCallback(async () => {
  if (!userDetails?.email) return;

  try {
    const response = await axios.post(
      API_REWARDBOT_URL,
      { email: userDetails.email },  // <-- send email in body
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    console.log("API response (reward status):", response.data);

    if (response.status === 200 && response.data) {
      setRewardClaimed(Number(response.data.rewardClaimed));
    } else {
      throw new Error(response.data?.message || 'Failed to fetch reward status');
    }
  } catch (error) {
    console.error('Failed to fetch reward status:', error);
  }
}, [userDetails?.email]);


useEffect(() => {
  fetchRewardStatus();
}, [fetchRewardStatus]); // ✅ Now fetchRewardStatus is stable and included
  

useEffect(() => {
    // Check if the user has not claimed the welcome reward
    if (rewardClaimed === 0) {
      setShowWelcomeModal(true);
    }
  }, [rewardClaimed]);


  
  const handleToggleTheme = () => setDarkMode(prev => !prev);
  const handleBotActivation = () => setShowConfirm(true);

  const confirmBotActivation = async (method) => {
    setShowConfirm(false);
    setBotLoading(true);
    const { username } = userDetails || {}; 

    const requiredCoins = 500000;
    const requiredBalance = 5;

    const hasEnoughCoins = coins >= requiredCoins;
    const hasEnoughBalance = balance >= requiredBalance;

    if (method === 'coins' && !hasEnoughCoins) {
      toast.error("You need at least 500,000 coins to activate the bot.");
      setBotLoading(false);
      return;
    }

    if (method === 'balance' && !hasEnoughBalance) {
      toast.error("You need at least $5 to activate the bot.");
      setBotLoading(false);
      return;
    }

    

    const newCoins = method === 'coins' ? coins - requiredCoins : coins;
    const newBalance = method === 'balance' ? balance - requiredBalance : balance;

    try {
      const response = await axios.post(API_ACTIVATEBOT_URL, {username,
        coins: newCoins,
        balance: newBalance,
        activationTime: new Date().toISOString(),
      });

      if (response.status === 200 && response.data?.success) {
        setCoins(newCoins);
        setBalance(newBalance);
        setBotActive(true);
        toast.success("Bot activated successfully.");

        // Optionally, you can also update the userDetails state here if needed
        // For example, if you want to update the botStatus:
  
     // Assuming botStatus is 1 for active
      } else if (response.data?.error) {
        throw new Error(response.data.error);

      } else {
        const apiMessage = response.data?.message || "Bot activation failed.";
        throw new Error(apiMessage);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Error activating bot. Please try again.");
    } finally {
      setBotLoading(false);
    }
  };

  // This effect runs once on mount to check if reward has been claimed
  // Simulation text for bot activity passed as element

  const handleClaimBonus = async () => {

    if (claimLoading) return; // prevent multiple clicks
    setClaimLoading(true);

    const newCoins = coins + dailyCoins;
    const { username } = userDetails || {}; 
  
    try {
      const response = await axios.post(API_CLAIMCOIN_URL, {username,
        coins: newCoins,
        dailyCoins: 0,
      });
  
      if (response.status === 200 && response.data?.success) {
        setCoins(newCoins);
        setDailyCoins(0);
        toast.success("Daily coins claimed!");
      } else {
        throw new Error(response.data?.message || "Failed to claim daily bonus.");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Error claiming daily bonus.");
    }
    finally {
      setClaimLoading(false);
    }
  };
  
  if (loading) return <Spinner />;
  if (error) return <ErrorMessage message={error} />;

  const {
    tier = 'Not selected',
        investedAmount = '0.00',
    end_time = 'N/A',
    username = ''
  } = userDetails || {};

 const CoinTracker = ({
  coins,
  dailyCoins,
  onClaimBonus,
  claimLoading,
  rewardClaimed,
  setShowWelcomeModal
}) => {
  const disableClaim = dailyCoins === 0 || claimLoading;

  return (
    <div style={styles.coinBox}>
      
      <p><strong>Coins:</strong> {coins}</p>
      <p><strong>Daily Coins:</strong> {dailyCoins}</p>
      
<div style={{ display: 'flex', gap: '12px', marginTop: '10px', justifyContent: 'center' }}>
      <motion.button
        onClick={onClaimBonus}
        style={styles.claimButton}
        disabled={disableClaim}
        whileTap={{ scale: 0.95 }}
        whileHover={{ scale: 1.05 }}
        aria-busy={claimLoading}
        aria-disabled={disableClaim}
      >
        {claimLoading ? (
          <>
            Claiming...
            <ButtonSpinner />
          </>
        ) : (
          'Claim Daily Bonus'
        )}
      </motion.button>

      {/* Conditionally render the Welcome Claim button */}
      {rewardClaimed === 0 && (
        <motion.button
          onClick={() => setShowWelcomeModal(true)}
          style={{ ...styles.claimButton, backgroundColor: '#17a2b8', marginTop: '12px' }}
          whileTap={{ scale: 0.95 }}
          whileHover={{ scale: 1.05 }}
        >
          🎉 Claim Welcome Coin
        </motion.button>
       
      )}
      </div>
    </div>
  );
};



  return (
    <div style={{ ...styles.container, backgroundColor: darkMode ? '#1e1e1e' : '#fff', color: darkMode ? '#f0f0f0' : '#000' }}>
      <ToastContainer />
         <button
        onClick={handleToggleTheme}
        aria-label="Toggle Dark Mode"
        style={styles.themeToggle}
      >
        {darkMode ? '🌞 Light Mode' : '🌙 Dark Mode'}
      </button> 
 
      <motion.div className="container my-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
               <p>Welcome, <strong>{username}</strong></p>
        </motion.div>
   
    

      <div style={styles.infoBox}>
      <p><strong>Your Current Plan:</strong> {tier ?? "No plan yet"}</p>
  <p><strong>You have invested:</strong> ${Number(investedAmount).toLocaleString()}</p>
  <p><strong>Investment Plan Maturity Date:</strong> {end_time ?? 'Will be calculated after you choose a Plan'}</p>
  <p><strong>Total Earned Balance:</strong> ${botEarn.toFixed(2)}</p>
 
</div>
      <ReferralInfo />

      <motion.div style={styles.botStatusBox} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
  {botActive && (
    <>
      <BotCandlestickChart botActive={botActive} />
    </>
  )}
  <p><strong>Bot Status:</strong> {botActive ? 'Active ✅' : 'Inactive ❌'}</p>
  <p>{botActive ? 'Bot is currently active and optimizing your plan.' : 'Activate your bot for more insights.'}</p>

  {!botActive && !tier && (
    <p style={{ color: '#d9534f', marginTop: '12px', fontWeight: '600' }}>
      Please select a plan to activate the bot.
    </p>
  )}

  {!botActive && tier && (
    <button
      onClick={handleBotActivation}
      style={{ ...styles.toggleButton }}
      disabled={botLoading}
    >
      {botLoading ? 'Activating...' : 'Activate Bot'}
    </button>
  )}

  {!botActive && tier && (coins < 500000 && balance < 5) && (
    <p style={{ color: '#d9534f', marginTop: '12px', fontWeight: '600' }}>
      You need 500,000 SVP Coins or $5 to activate the bot.
    </p>
  )}
</motion.div>

   <CoinTracker
  coins={coins}
  dailyCoins={dailyCoins}
  onClaimBonus={handleClaimBonus}
  claimLoading={claimLoading}
  rewardClaimed={rewardClaimed}
  setShowWelcomeModal={setShowWelcomeModal}
/>


      <div style={styles.dailyTaskBox}>
        <p>Complete your daily tasks to earn more coins!</p>
        <a href="/dashboard/dailytask" style={styles.dailyTaskButton}>Go to Daily Task</a>
        <a href="/dashboard/stakingroom" style={styles.dailyTaskButton}>Stake Funds</a>
      </div>


      <HelpBox />

      <footer style={styles.footer}>
        <div style={styles.footerLinks}>
          <a href="/policy.html" style={styles.footerLink}>Privacy Policy</a>
          <a href="/terms.html" style={styles.footerLink}>Terms & Conditions</a>
        </div>
      </footer>


      {showConfirm && (
        <CustomConfirmModal
          onSelect={confirmBotActivation}
          onClose={() => setShowConfirm(false)}
        />
      )}

      {showWelcomeModal && (
  <div role="dialog" aria-modal="true" style={styles.modalOverlay}>
    <div style={styles.modalContent}>
      <h3 style={{ marginBottom: '12px' }}>🎁 Claim Your 💰 20,000 Welcome Coin Reward</h3>
      <p style={{ marginBottom: '10px' }}>
        To receive your welcome coins, please:
      </p>
      <ol style={{ textAlign: 'left', marginBottom: '20px' }}>
        <li>Click the button below to open our Telegram bot.</li>
        <li>Complete the short task inside the Telegram chat.</li>
        <li>Return here and click <strong>“I’ve Done It”</strong>.</li>
      </ol>

      <a
        href="https://t.me/SvpRewardBot"
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...styles.claimButton, backgroundColor: '#0088cc', marginBottom: '12px' }}
      >
        🔗 Go to Telegram
      </a>

     <button
  onClick={async () => {
    await fetchRewardStatus(); // Refetch data
    setShowWelcomeModal(false); // Close modal
    toast.success("Welcome reward status updated!");
  }}
  style={{ ...styles.modalButton, backgroundColor: '#28a745' }}
>
  ✅ I’ve Done It
</button>

      <button
        onClick={() => setShowWelcomeModal(false)}
        style={{ ...styles.modalButton, backgroundColor: '#6c757d', marginTop: '10px' }}
      >
        Cancel
      </button>
    </div>
  </div>
)}
      {loading && <Spinner />}
      {error && <ErrorMessage message={error} />}

    </div>
  );
};

// STYLES
const styles = {
  container: { padding: '24px 20px', maxWidth: '900px', margin: '0 auto', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", transition: 'background-color 0.3s ease, color 0.3s ease', minHeight: '100vh', display: 'flex', flexDirection: 'column', gap: '24px' },
  header: { position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', padding: '1rem', backgroundColor: '#f5f5f5',color: '#333', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' },
  welcome: { fontSize: '1.2rem', marginBottom: '0.5rem', flex: '1 1 100%', textAlign: 'center' },
  themeToggle: { position: 'absolute', padding: '8px 14px', top: '10rem', right: '2.5rem', transition: 'background-color 0.3s ease', background: '#007bff', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '400', minWidth: '100px', fontSize: '1rem' },
  infoBox: { backgroundColor: '#f7f9fc', borderRadius: '8px', padding: '20px 24px', boxShadow: '0 2px 8px rgb(0 0 0 / 0.05)', lineHeight: 1.6 },
  referralInfo: { marginTop: '20px', fontSize: '0.9rem', color: '#555', lineHeight: 1.5 },
  coinBox: { marginTop: '20px', padding: '18px 24px', backgroundColor: '#e6f4ea', border: '1px solid #c3dec9', borderRadius: '8px', textAlign: 'center', fontWeight: '600', fontSize: '1.1rem' },
  claimButton: { marginTop: '12px', padding: '12px 18px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '1rem', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px', transition: 'background-color 0.3s ease' },
  botStatusBox: { padding: '18px 24px', backgroundColor: '#eef6fd', border: '1px solid #c9defd', borderRadius: '8px', marginTop: '24px', textAlign: 'center', fontWeight: '600', fontSize: '1rem' },
  toggleButton: { marginTop: '16px', padding: '12px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '1rem', transition: 'background-color 0.3s ease' },
  dailyTaskBox: { marginTop: '24px', padding: '20px 24px', backgroundColor: '#fff8e1', border: '1px solid #ffecb3', borderRadius: '8px', textAlign: 'center', fontWeight: '600', fontSize: '1rem', display: 'flex', flexDirection: 'column', gap: '16px' },
  dailyTaskButton: { padding: '12px 18px', backgroundColor: '#ffc107', color: '#212529', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '1rem', textDecoration: 'none', display: 'inline-block', transition: 'background-color 0.3s ease' },
  helpBox: { padding: '24px 24px', border: '1px solid #d0d7de', marginTop: '30px', backgroundColor: '#fafafa', borderRadius: '8px', textAlign: 'center', color: '#333' },
  linkContainer: { display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '24px', marginTop: '14px' },
  link: { textDecoration: 'none', display: 'inline-flex', alignItems: 'center', transition: 'transform 0.2s ease' },
  linkHover: { transform: 'scale(1.1)' },
  icon: { width: '60px', height: '60px' },
  footer: { padding: '24px 20px', textAlign: 'center', marginTop: '40px', borderTop: '1px solid #ccc', fontSize: '0.9rem', color: '#666' },
  footerLinks: { display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '8px' },
  footerLink: { textDecoration: 'none', color: '#007bff', fontSize: '14px', margin: '0 10px', fontWeight: '500' },
  errorBox: { padding: '20px', backgroundColor: '#ffe6e6', color: '#cc0000', border: '1px solid #cc0000', marginTop: '20px', borderRadius: '6px', textAlign: 'center', fontWeight: '600' },
  spinnerContainer: { textAlign: 'center', marginTop: '140px' },
  spinner: { border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '50px', height: '50px', animation: 'spin 1s linear infinite', margin: 'auto' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '12px' },
  modalContent: { backgroundColor: '#fff', padding: '30px 36px', borderRadius: '10px', textAlign: 'center', maxWidth: '420px', boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)' },
  modalButton: { marginTop: '18px', padding: '14px 24px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontSize: '1rem', width: '100%', transition: 'background-color 0.3s ease' },
  buttonSpinner: { border: '2px solid #f3f3f3', borderTop: '2px solid white', borderRadius: '50%', width: 16, height: 16, animation: 'spin 1s linear infinite', marginLeft: 8 },

  '@media (max-width: 768px)': {
    container: { padding: '20px 12px' },
    header: { flexDirection: 'column', alignItems: 'flex-start', gap: '8px' },
    welcome: { textAlign: 'center', flex: '1 1 100%', marginBottom: '0.5rem' },
    themeToggle: { width: '100%', minWidth: 'auto' },
    coinBox: { fontSize: '1rem', padding: '14px 18px' },
    claimButton: { fontSize: '0.9rem', padding: '10px 14px' },
    botStatusBox: { fontSize: '0.9rem', padding: '16px 18px' },
    toggleButton: { fontSize: '0.9rem', padding: '10px 14px' },
    dailyTaskBox: { padding: '18px 18px', fontSize: '0.9rem', gap: '12px' },
    dailyTaskButton: { fontSize: '0.9rem', padding: '10px 14px' },
    modalContent: { padding: '20px 24px', maxWidth: '90vw' },
    modalButton: { fontSize: '0.9rem', padding: '12px 18px' },
    icon: { width: '48px', height: '48px' }
  },

  '@media (min-width: 600px)': {
    header: { flexDirection: 'row' },
    welcome: { flex: '0 1 auto', textAlign: 'left', marginBottom: 0 }
  }
};
// Injecting keyframes for spinner animation
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, styleSheet.cssRules.length);

export default Home;
